import fetch, { IBaseResponse } from 'lib/decorated-fetch'
import getUrl from 'lib/url'
export interface INewEnergyTypeData {
  options?: IRankDataFilterOptions[] //车系type 细分类型   param=1,纯电动， param=2插电式混动
  key?: string //车系type 所属key
  text?: string //车系type name
}
export interface IRankConfigData {
  filters?: IRankDataFilterData[] //过滤参数
  sells_rank_month?: IRankMonthData[] //销量月份数据
  new_energy_type?: INewEnergyTypeData[] //新能源过滤参数
  is_publish_time?: boolean //是否发榜时间
}
export interface IRankDataFilterData {
  data?: IRankDataFilterOptionsData //车系type 细分类型
  key?: string //车系type 所属key
  text?: string //车系type name
}
export interface IRankDataFilterOptions {
  params?: string //条件参数
  text?: string //文本
}
export interface IRankDataFilterOptionsData {
  options?: IRankDataFilterOptions[]
}
export interface IRankMonthData {
  month?: string //月份字段
  text?: string //月份文本
}
export default async function (req?: any) {
  const response: IBaseResponse<IRankConfigData> = await fetch(
    getUrl('/motor/pc/car/rank_data_config', 'motor.pc_car.api'),
    { req }
  )
  if (0 !== response?.status) {
    throw Error(response?.prompts || response.message)
  }
  return response?.data
}
